import { get } from '@/api/apiService.ts';
import type {
  DebugCompany,
  DebugSessionDetail,
  DebugSessionsQuery,
  PaginatedDebugSessionsResponse,
} from '@/types/superUserDebug.ts';

function buildQueryString(query: DebugSessionsQuery): string {
  const params = new URLSearchParams();
  if (query.companyId) params.set('companyId', query.companyId);
  if (query.salespersonId) params.set('salespersonId', query.salespersonId);
  if (query.simulationId) params.set('simulationId', query.simulationId);
  if (query.dateFrom) params.set('dateFrom', query.dateFrom);
  if (query.dateTo) params.set('dateTo', query.dateTo);
  if (query.status) params.set('status', query.status);
  if (query.q) params.set('q', query.q);
  if (query.page !== undefined) params.set('page', String(query.page));
  if (query.pageSize !== undefined) params.set('pageSize', String(query.pageSize));
  if (query.sort) params.set('sort', query.sort);
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

const superUserDebugService = {
  getSessions(query: DebugSessionsQuery = {}): Promise<PaginatedDebugSessionsResponse> {
    return get<PaginatedDebugSessionsResponse>(
      `/api/superuser/debug/sessions${buildQueryString(query)}`,
    );
  },

  getSessionDetail(sessionId: string): Promise<DebugSessionDetail> {
    return get<DebugSessionDetail>(`/api/superuser/debug/sessions/${sessionId}`);
  },

  getCompanies(): Promise<DebugCompany[]> {
    return get<DebugCompany[]>('/api/superuser/debug/companies');
  },
};

export default superUserDebugService;
